export const stockCorrectionsDicionaryError: Record<string, string> = {
  'stock.errors.stock_less_than_reserved': 'Existe reservas para essa peça.',
};
